import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import en from "./locales/en.json";
import de from "./locales/de.json";
import fr from "./locales/fr.json";
import it from "./locales/it.json";

const STORAGE_KEY = "rekinder_language";
const saved = localStorage.getItem(STORAGE_KEY);
const browserLang = navigator.language.slice(0, 2);
const defaultLang = saved ?? (["de", "fr", "it"].includes(browserLang) ? browserLang : "en");

i18n
  .use(initReactI18next)
  .init({
    resources: { en: { translation: en }, de: { translation: de }, fr: { translation: fr }, it: { translation: it } },
    lng: defaultLang,
    fallbackLng: "en",
    interpolation: { escapeValue: false },
  });

i18n.on("languageChanged", (lng) => localStorage.setItem(STORAGE_KEY, lng));

export default i18n;
